var Assam = "Assam";
var Bihar = "Bihar";
var Chandigarh = "Çandigarh";
var Chhattisgarh = "Çatisgar";
var Delhi = "Delhi";
var Goa = "Goa";
var Gujarat = "Gücerat";
var Haryana = "Haryana";
var Jharkhand = "Carkhand";
var Karnataka = "Karnataka";
var Kerala = "Kerala";
var Lakshwadeep = "Lakşadvip";
var Maharashtra = "Maharaştra";
var Manipur = "Manipur";
var Meghalaya = "Meghalaya";
var Mizoram = "Mizoram";
var Nagaland = "Nagaland";
var Orrisa = "Orrisa";
var Puducherry = "Puducherry";
var Punjab = "Pencap";
var Rajasthan = "Racastan";
var Sikkim = "Sikkim";
var Telangana = "Telangana";
var Tripura = "Tripura";
var Uttrakhand = "Uttarakhand";
var INStates = {
	"Andaman and Nicobar Islands": "Andaman ve Nicobar Adaları",
	"Andhra Pradesh": "Andhra Pradeş",
	"Arunachal Pradesh": "Arunaçal Pradeş",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "Dadra ve Nagar Haveli",
	"Daman & Diu": "Daman ve Diu",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "Himaçal Pradeş",
	"Jammu and Kashmir": "Cemmu ve Keşmir",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "Madya Pradeş",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "Tamil Nadu",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "Uttar Pradeş",
	Uttrakhand: Uttrakhand,
	"West Bengal": "Batı Bengal"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
